<div id="member-join-container" class="d-flex align-items-center m-0 flex-column">
  <div class="w-100 h-100">
    <div class="form-content d-flex flex-column">
      <div class="member-join-row">

        <canvas></canvas>

        <div class="flex-fill">
          <div class="pt-0">
            <div class="content-parent" [ngClass]="{ mobile: innerWidth < 992 }">
              <div class="d-flex flex-fill content-steps">

                <!-- left col -->
                <div class="w-40 member-join-bg d-flex flex-column">
                  <app-nmj-info-display [step]="currentStep$|async"
                    [isCompleted]="completed$|async"></app-nmj-info-display>
                </div>

                <!-- right col -->
                <div class="w-60 d-flex content-margin right-side" appanimatecss>

                  <div class="main-container w-100">
                    <!-- error page -->
                    <ng-container *ngIf="errorPage$|async">
                      <div appanimatecss class="error-page" *ngIf="errorPage$ | async; let errorPage">
                        <h4 class="description">
                          We are unable to complete your application. Please
                          <a href="https://vervesuper.com.au/contact-us/" target="_blank">get in touch</a>
                          with our team for assistance.
                        </h4>
                      </div>
                    </ng-container>

                    <div class="d-flex flex-column content-container" [ngClass]="{'justify-content-center': (centerContent$|async)}">
                      <div class="ng-progressbar col-12 p-0" *ngIf="(currentStep$|async)>0 && !(errorPage$|async)">
                        <mat-progress-bar mode="determinate" [value]="progress" class=""></mat-progress-bar>
                      </div>

                      <!-- non error page -->
                      <ng-container *ngIf="!(errorPage$|async) && !(completed$|async)">

                        <!-- steps for nmj -->
                        <ng-container *ngIf="!(completed$|async)">

                          <ng-container *ngIf="(currentStep$|async) === 0">
                            <app-nmj-initial-data [step]="currentStep$ | async"></app-nmj-initial-data>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 1">
                            <app-nmj-details [step]="currentStep$|async"></app-nmj-details>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 2">
                            <app-nmj-mobile-verification [step]="currentStep$|async"></app-nmj-mobile-verification>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 3">
                            <app-nmj-investments [step]="currentStep$|async"></app-nmj-investments>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 4">
                            <app-nmj-tfn [step]="currentStep$|async"></app-nmj-tfn>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 5">
                            <app-nmj-terms-conditions [step]="currentStep$|async"></app-nmj-terms-conditions>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 6">
                            <app-nmj-rollin [step]="currentStep$|async"></app-nmj-rollin>
                          </ng-container>

                          <ng-container *ngIf="(currentStep$|async) === 7">
                            <app-nmj-review [step]="currentStep$|async"></app-nmj-review>
                          </ng-container>
                        </ng-container>

                      </ng-container>

                      <!-- completion -->
                      <ng-container *ngIf="completed$|async">
                        <app-nmj-finished></app-nmj-finished>
                      </ng-container>
                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>



  <div id="overlay" *ngIf="(isLoading$ | async)" class="animate__animated animate__bounceIn" appanimatecss>
    <div class="overlay-container">
      <mat-progress-spinner diameter="100" class="app-spinner animate__animated animate__bounceIn"
        mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
</div>